<template>
  <div>
    <v-tooltip
      open-on-hover
      location="bottom"
      color="black"
    >
      <template #activator="{ props }">
        <div
          v-bind="props"
        >
          <v-icon
            class="ml-2"
            icon="image"
            size="1.1rem"
          />
        </div>
      </template>
      <v-img
        contain
        :src="`data:image/png;base64,${showImage}`"
        alt="machine image"
        height="15rem"
        width="15rem"
        max-height="15rem"
        max-width="15rem"
      />
    </v-tooltip>
  </div>
</template>

<script>
export default {
  props: {
    showImage: {
      type: String,
      default: null,
    },
  },
  data: () => ({
  }),
};
</script>
